import { post } from "@/utils/axiosInstance";
import router from "@/router";
import { statuses, ENDPOINTS } from "../../constants";

const state = {
  customer: {},
  customerBefore: {},
  customerStatus: null,
};

const actions = {
  searchCustomer({ commit }, customerNo) {
    return new Promise((resolve) => {
      if (customerNo.cusId === undefined) {
        customerNo.cusId = null;
      }
      post(
        ENDPOINTS.customerSearch,
        { customerNo: customerNo.customerNo },
        {},
        customerNo.cusId
      ).then((response) => {
        if (response.data) {
          if (
            response.data.statusCode === statuses.INTERNAL_SERVER_ERROR &&
            window.location.pathname !== "/"
          ) {
            if (customerNo.customerNo != "0") {
              router.push({ name: "Home" });
            }
          }
          commit("setCustomer", response.data);
          resolve(response.data);
        } else {
          resolve(false);
        }
      });
    });
  },
  handleCustomer({ commit }, value) {
    commit("setCustomer", value);
  },
  searchCustomerBefore({ commit }, SearchValue) {
    return new Promise((resolve) => {
      post(ENDPOINTS.customerSearchBefore, SearchValue).then((response) => {
        if (response.data) {
          commit("setCustomerBefore", response.data);
          resolve(response.data);
        } else {
          resolve(false);
        }
      });
    });
  },
  // eslint-disable-next-line no-unused-vars
  movePurchaseDates({ commit }, purchaseID) {
    return new Promise((resolve) => {
      post(ENDPOINTS.customerMoveStartDate, purchaseID).then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          resolve(false);
        }
      });
    });
  },
  updatePaymentStatus({ commit }, args) {
    return new Promise((resolve) => {
      post(ENDPOINTS.updatePaymentStatus, args, null, args.customerId).then(
        (response) => {
          if (response.status === statuses.OK) {
            commit("setPaymentStatus", response.data);
            resolve(true);
          } else {
            resolve(false);
          }
        }
      );
    });
  },
  clearCustomerData({ commit }) {
    commit("setCustomer", []);
  },
};

const mutations = {
  setCustomer(state, customer) {
    state.customer = customer;
  },
  setCustomerBefore(state, customerBefore) {
    state.customerBefore = customerBefore;
  },
  setPaymentStatus(state, status) {
    state.customerStatus = status;
  },
};

const getters = {
  customer() {
    return state.customer;
  },
  customerBefore() {
    return state.customerBefore;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
